module.exports = __webpack_public_path__ + "static/media/reward.daef3728.gif";